import React from "react";
import Slider from "react-slick";
import classNames from 'classnames';
import get from "lodash/get";
import { Link, ResponsiveHeroImage, ReviewRating } from "@quintype/components";
import { DfpAd } from "../dfp-ad"
import { ImageFallback } from "../basic/image-fallback.js";

function OneMainCardSlider(props) {
  const settings = {
      dots: false,
      infinite: true,
      speed: 600,
      arrows: true,
      centerMode: true,
      autoplay: true,
      autoplaySpeed: 5000,
      centerPadding: '270px',
      slidesToShow: 1,
      rtl: get(props.config, ['theme-attributes', 'language_direction']) === 'right',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerPadding: '20px',
            slidesToShow: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            centerPadding: '20px',
            slidesToShow: 1
          }
        }
      ]
    };
  const stories = props.stories ? props.stories.slice(0, 5) : [];
  return stories.length < 3 ? null : <div className="one-main-card-slider component-wrapper-fluid">
      <div className="component-wrapper">
      <Slider {...settings} className="one-main-card-slider__slides">
        {stories.map((item) =>
          <div key={item.id} className="one-main-card-slider__slider-content">
            <SliderItem item={item} languageDirection={props.languageDirection}/>
          </div>
        )}
      </Slider>
      </div>
      <div className="app-ad app-ad--horizontal">
        <DfpAd adtype="Horizontal-Ad" layoutName="OneMainCardSlider" collectionSlug={props.config['collection-slug']}/>
      </div>
    </div>
}

function SliderItem(props) {
  {/* The `story` can be an item from items of a collection or a story itself.
   assigning it accordinlgy.*/}
  const story = props.item.type === 'story' && props.item.story ? props.item.story : props.item;
  const isReviewStory = story["story-template"] == 'review' ? true : false;
  return (
    <Link className={classNames('overlay-story-card', {'overlay-story-card--video': story['story-template'] === 'video'})} href={"/" + story.slug }>
    { story["hero-image-s3-key"] ?
      <figure>
        <ResponsiveHeroImage story={story}
          aspectRatio={[57,32]}
          defaultWidth={320} widths={[250,480,640]}
          imgParams={{auto:['format', 'compress'], fit:'max'}}/>
      </figure> :
      <ImageFallback/> }
      {isReviewStory && <ReviewRating value={get(story, ['metadata','review-rating', 'value'], '0')} />}
      <p className={`overlay-story-card__heading ${props.languageDirection === "right" ? 'content-right' : ''}`} dangerouslySetInnerHTML={ {__html: story.headline }} />
    </Link>
  )
}

export { OneMainCardSlider };
